import Vue from 'vue'
import VueGtag from 'vue-gtag'

const GTAG_ID = 'G-Z5NTVMV7CK'

Vue.use(VueGtag, {
  config: { id: GTAG_ID }
})

if (import.meta.env.PROD) {
  const script1 = document.createElement('script')
  script1.async = true
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`
  document.head.appendChild(script1)

  script1.onload = () => {
    const script2 = document.createElement('script')
    script2.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GTAG_ID}');
    `
    document.head.appendChild(script2)
  }
}
